import { useEffect, useState, forwardRef } from "react";
import { format } from "date-fns";

import { colors, Typography } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { colorsCupons } from "helpers/constants";

// Images
import logoCT from "assets/images/logo-ct.png";
import { ICupomEvento } from "interfaces/cupom";
import { generateQRCodeSVG } from "helpers/qrCodeGenerator";

interface Props {
  data: ICupomEvento;
  color?: string | number;
}

function getRandomColor(): string {
  const randomIndex = Math.floor(Math.random() * colorsCupons.length);
  return colorsCupons[randomIndex];
}

const baseUrlEvento = "https://www.tnvteam.com.br/evento/";

const Cupom = forwardRef<HTMLDivElement, Props>(({ data, color }, ref) => {
  const [qrCodeSVG, setQrCodeSVG] = useState<string>("");

  useEffect(() => {
    async function fetchQRCode() {
      const svg = await generateQRCodeSVG(
        `${baseUrlEvento}${data.evento.slug}`
      );
      setQrCodeSVG(svg);
    }
    fetchQRCode();
  }, [data]);

  return (
    <MDBox
      display="flex"
      alignItems="center"
      borderRadius="lg"
      width={450}
      height={186}
      overflow="hidden"
      ref={ref}
    >
      {/* DADOS DO CUPOM */}
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        width="60%"
        height="100%"
        p={1}
        borderRadius="lg"
        bgColor={color ? color.toString() : data.colorField}
      >
        <MDBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            width: "100%",
            m: 0,
          }}
        >
          <MDBox>
            <MDTypography
              color="white"
              variant="body2"
              fontWeight="bold"
              textTransform="uppercase"
            >
              CUPOM
            </MDTypography>
            <MDTypography
              color="white"
              variant="body2"
              fontWeight="bold"
              textTransform="uppercase"
            >
              DESCONTO
            </MDTypography>
          </MDBox>
          <MDBox component="img" src={logoCT} width="60px" alt="Logo" />
        </MDBox>
        {/* CODIGO */}
        <MDBox
          display="flex"
          flexDirection="column"
          justifyItems="center"
          alignItems="center"
        >
          <MDTypography
            width="100%"
            sx={{ color: colors.grey[200], fontSize: 16 }}
            color="white"
            variant="h4"
            fontWeight="regular"
            align="center"
            textTransform="uppercase"
          >
            {data.valorCupom}% OFF
          </MDTypography>
          <Typography
            width="100%"
            sx={{ color: colors.orange[700], fontSize: 26, fontWeight: "bold" }}
            fontWeight="bold"
            letterSpacing={1.3}
            align="center"
            textTransform="uppercase"
          >
            {data.codigoPromocional}
          </Typography>
        </MDBox>

        <MDBox>
          <MDTypography
            color="white"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
          >
            Validade:{" "}
            {format(
              data.validade.slice(0, 10).concat("T23:59:59.000Z"),
              "dd/MM/yyyy"
            )}
          </MDTypography>
          <MDTypography
            sx={{ fontSize: 10 }}
            color="white"
            fontWeight="regular"
            textTransform="uppercase"
          >
            {data.evento.titulo}
          </MDTypography>
        </MDBox>
      </MDBox>
      {/* QRcode do cupom */}
      <MDBox
        display="flex"
        width="40%"
        height="100%"
        p={1}
        borderRadius="lg"
        bgColor={color ? color.toString() : data.colorField}
        sx={{ borderLeft: "2px dashed white" }}
      >
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="lg"
          width="100%"
          height="auto"
          p={1}
          sx={{ backgroundColor: "white" }}
          dangerouslySetInnerHTML={{ __html: qrCodeSVG }}
        />
      </MDBox>
    </MDBox>
  );
});

export default Cupom;
